export const LOGIN = '/login'
export const DEPLOY = '/deploy'
export const HOME = '/'
export const DEBUG = '/debug'
export const ONEONONEQUESTIONS = '/one-on-one-questions'
export const ONEONONETOPICS= '/one-on-one-topics'
export const DATA = '/data'
export const CAMPFIRES = '/campfires'
